import Vue from 'vue'
import fontawesome from '@fortawesome/fontawesome'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {
  faArrowCircleRight,
  faArrowCircleLeft
} from '@fortawesome/fontawesome-free-solid'

fontawesome.library.add(
  faArrowCircleRight,
  faArrowCircleLeft
)

Vue.component('font-awesome-icon', FontAwesomeIcon) // registered globally



// WEBPACK FOOTER //
// ./resources/js/fa.config.js